import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { NavLink } from 'react-router-dom'
import {isArrayNotEmpty, isCompletedHotelInfoHistory} from 'utilities/JSUtil'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import DestinationsService from '../../../../services/DestinationsService'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Table from '../../../molecules/Table/Table'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Destinations.scss'

export class Destinations extends Component {

  constructor(props) {
    super(props)

    const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
    const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
    const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

    if (!hotelCode || !hotelInfo) {
      this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
    }
    const hotelBrandCode = hotelInfo.brandCode;
    let availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];
    let canAccessHotelContentSpa =  false;
    if (availableHotelContent !== undefined && availableHotelContent.includes('S')) {
        canAccessHotelContentSpa = true;
    }

    this.state = {
      hotelCode: hotelCode,
      hotelInfo: hotelInfo,
      hotelDestinations: [],
      isLoading: true,
      loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
      hotelDestinationStatus: {
        'restaurant': FormConst.VALUE_PENDING,
        'lounge': FormConst.VALUE_PENDING,
        'attraction': FormConst.VALUE_PENDING,
        'business': FormConst.VALUE_PENDING,
        'airport': FormConst.VALUE_PENDING,
        'spa': FormConst.VALUE_PENDING,
        'longDistanceTransportation': FormConst.VALUE_PENDING,
        'localTransportation': FormConst.VALUE_PENDING
      },
      canAccessHotelContentSpa: canAccessHotelContentSpa,
      hotelInfoCompletedHistory: hotelInfoCompletedHistory
    }
  }

  hotelDestinationLabels = {
    'restaurant': 'Restaurants',
    'lounge': 'Lounges',
    'attraction': 'Attractions',
    'business': 'Businesses',
    'airport': 'Airports',
    'spa': 'On-Site Spa',
    'longDistanceTransportation': 'Long Distance Transportation',
    'localTransportation': 'Local Transportation'
  }

  localAttractionTypes = ['restaurant', 'lounge', 'attraction', 'business', 'spa']

  transportationTypes = ['airport', 'transportation']

  headers = ['Destination Type', 'Status', 'Action']

  hotelDestinationRoutes = {
    'restaurant': RouteConst.ROUTE_RESTAURANTS_PAGE,
    'lounge': RouteConst.ROUTE_LOUNGES_PAGE,
    'attraction': RouteConst.ROUTE_ATTRACTIONS_PAGE,
    'business': RouteConst.ROUTE_BUSINESSES_PAGE,
    'airport': RouteConst.ROUTE_AIRPORTS_PAGE,
    'spa': RouteConst.ROUTE_SPA_PAGE,
    'longDistanceTransportation': RouteConst.ROUTE_LONG_DISTANCE_TRANSPORTATION_PAGE,
    'localTransportation': RouteConst.ROUTE_LOCAL_TRANSPORTATION_PAGE
  }

  /**
   * Lifecycle method that runs after the component mounts.
   * Gets data from the session if state is COMPLETED, otherwise from the service, and sets initial values for the form.
   */
  async componentDidMount() {
    if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
      let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;
      if (hotelDestinations) {
        await this.buildFormValues(hotelDestinations);
      } else {
        this.setState({ hotelDestinations: [], isLoading: false });
      }
    } else {
      await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
          .then(async response => {
            let hotelDestinations = response?.hotelDestinations;
            if (hotelDestinations) {
              await this.buildFormValues(hotelDestinations);
            } else {
              this.setState({hotelDestinations: [], isLoading: false})
            }
          }).catch(error => {
            this.setState({
              isLoading: false, showErrorModal: true, errorMessage: 'There was an error while reading data'
            })
          })
    }
  }

  async buildFormValues(hotelDestinations) {
    let newStatusObject = { ...this.state.hotelDestinationStatus }

    // Update local attractions status
    this.localAttractionTypes.forEach(type => {
      if (hotelDestinations.hasOwnProperty(type)) {
        const destinationEntry = hotelDestinations[type]
        newStatusObject[type] = destinationEntry && destinationEntry.length >= FormConst.DESTINATIONS_CATEGORY_LOCAL_ATTRACTIONS_MIN_COUNT
            ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING
      }
    })

    // Update spa status
    if (this.state.canAccessHotelContentSpa) {
      if (hotelDestinations.hasOwnProperty('business')) {
        const destinationEntry = hotelDestinations['business']
        destinationEntry.forEach(businessEntry => {
          if (businessEntry.destinationType === FormConst.DESTINATION_TYPE_SPA) {
            newStatusObject['spa'] = FormConst.VALUE_COMPLETE
          }
        })
      }
    }

    // Update transportation status
    this.transportationTypes.forEach(type => {
      if (hotelDestinations.hasOwnProperty(type)) {
        const destinationEntry = hotelDestinations[type]
        if (type === 'transportation') {
          // Local and long distance transpoprtation have the same type 'transportation'
          // Check if both local and long distance transportation have min entries
          let localTransportationEntries = 0
          let longDistanceTransportationEntries = 0
          if (isArrayNotEmpty(destinationEntry)) {
            destinationEntry.forEach(transportationTypeEntry => {
              if (transportationTypeEntry.destinationType === FormConst.DESTINATION_TYPE_LOCAL_TRANSPORTATION) {
                localTransportationEntries++
              } else if (transportationTypeEntry.destinationType === FormConst.DESTINATION_TYPE_LONG_DISTANCE_TRANSPORTATION) {
                longDistanceTransportationEntries++
              }
            })
          }
          newStatusObject['localTransportation'] = localTransportationEntries >= FormConst.DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT
              ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING
          newStatusObject['longDistanceTransportation'] = longDistanceTransportationEntries >= FormConst.DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT
              ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING
        } else {
          // Airports
          newStatusObject[type] = destinationEntry && destinationEntry.length >= FormConst.DESTINATIONS_CATEGORY_TRANSPORTATION_MIN_COUNT ? FormConst.VALUE_COMPLETE : FormConst.VALUE_PENDING
        }
      }
    })
    this.setState({ hotelDestinations: hotelDestinations, hotelDestinationStatus: newStatusObject, error: undefined, isLoading: false })
  }

  onClickActionButton = (isComplete) => {
    if (isComplete) {
      this.props.history.push(RouteConst.ROUTE_ROOM_TYPES_PAGE)
    } else {
      // Get the first pending item
      let selectedType = 'restaurant'
      for (const type in this.state.hotelDestinationStatus) {
        if (this.state.hotelDestinationStatus.hasOwnProperty(type)) {
          const status = this.state.hotelDestinationStatus[type];
          if (type === 'spa' && !this.state.canAccessHotelContentSpa)
            continue;

          if (status === FormConst.VALUE_PENDING) {
            selectedType = type
            break
          }
        }
      }
      // Got to the page
      this.props.history.push({
        pathname: this.hotelDestinationRoutes[selectedType],
        state: {
          continueFlow: true
        }
      })
    }
  }

  render() {
    let buttonName = 'Start Editing'
    let localAttractionsTableData = []
    let transportationTableData = []
    let isComplete = true
    if (this.state.hotelDestinations) {

      if (Object.keys(this.state.hotelDestinations).length <= 1) {
        buttonName = 'Start Editing'

        for (const type in this.state.hotelDestinationStatus) {
          if (this.state.hotelDestinationStatus.hasOwnProperty(type)) {
            if (type === 'airport' || type === 'localTransportation' || type === 'longDistanceTransportation') {
              transportationTableData.push([this.hotelDestinationLabels[type], FormConst.VALUE_PENDING, <NavLink to={this.hotelDestinationRoutes[type]}>Add</NavLink>])
            } else if (type !== 'spa' || (type === 'spa' && this.state.canAccessHotelContentSpa)) {
              localAttractionsTableData.push([this.hotelDestinationLabels[type], FormConst.VALUE_PENDING, <NavLink to={this.hotelDestinationRoutes[type]}>Add</NavLink>])
            }
          }
        }
        isComplete = false
      } else {
        for (const type in this.state.hotelDestinationStatus) {
          if (this.state.hotelDestinationStatus.hasOwnProperty(type)) {
            const status = this.state.hotelDestinationStatus[type];
            if (type !== 'spa')
              isComplete = isComplete && status === FormConst.VALUE_COMPLETE
            if (type === 'airport' || type === 'localTransportation' || type === 'longDistanceTransportation') {
              transportationTableData.push([this.hotelDestinationLabels[type], status, <NavLink to={this.hotelDestinationRoutes[type]}>{status === FormConst.VALUE_COMPLETE ? 'Edit' : 'Add'}</NavLink>])
            } else if (type !== 'spa' || (type === 'spa' && this.state.canAccessHotelContentSpa)) {
              localAttractionsTableData.push([this.hotelDestinationLabels[type], status, <NavLink to={this.hotelDestinationRoutes[type]}>{status === FormConst.VALUE_COMPLETE ? 'Edit' : 'Add'}</NavLink>])
            }
          }
        }

        if (isComplete) {
          buttonName = 'Next Section'
        } else {
          buttonName = 'Continue Editing'
        }
      }
    }

    return (
      <div className='hotel-destinations'>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><NavLink to='/'>Home</NavLink></li>
            <li className="breadcrumb-item active" aria-current="page">Destinations</li>
          </ol>
        </nav>
        {
          !this.state.isLoading
          && (
            <>
              <p className='hotel-destinations-title'>Local Attractions</p>
              <p className='helper-text'>{FormConst.DESTINATIONS_LOCAL_ATTRACTIONS_HELPER_TEXT}</p>
              <Table bordered striped headers={this.headers} data={localAttractionsTableData} className='hotel-destinations-table' />
              <p className='hotel-destinations-title'>Transportation</p>
              <p className='helper-text'>{FormConst.DESTINATIONS_TRANSPORTATION_HELPER_TEXT}</p>
              <Table bordered striped headers={this.headers} data={transportationTableData} className='hotel-destinations-table' />
              {
                isComplete
                && (
                  <div className="alert alert-success" role="alert">
                    <h4 className="alert-heading">Well done!</h4>
                    <p>Aww yeah, you successfully finished this module. Let's proceed to the <NavLink to={SideNavEntryMapping.HOTEL_DESTINATIONS.next.route} className='alert-link'>next</NavLink> module</p>
                  </div>
                )
              }
            </>
          )
        }
        <FormFooter
          form={SideNavEntryMapping.HOTEL_DESTINATIONS}
          submitName={buttonName}
          onSubmit={() => this.onClickActionButton(isComplete)}
          noReset />
        <FormModal
          id='hotel-destinations-page-loading-modal'
          hotelInfo={this.state.hotelInfo}
          title={FormConst.MODAL_UPDATE_ACTION_TITLE}
          body={<h5>{this.state.loadingMessage}</h5>}
          show={this.state.isLoading}
          isLoadingIndicator />
        <FormModal
          id='hotel-destinations-page-error-modal'
          hotelInfo={this.state.hotelInfo}
          title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
          body={<h5>{this.state.errorMessage}</h5>}
          isError
          cancel={() => { this.setState({ showErrorModal: false }) }}
          show={this.state.showErrorModal} />
      </div>
    )
  }
}

export default withRouter(withFormLayout(Destinations, SideNavEntryMapping.HOTEL_DESTINATIONS))